import {
  ColumnId,
  DetailColumnId,
} from '@sales-portal/domain/pricing/screens/customers/types';
import { FilterFn } from '@tanstack/react-table';
import { PricingCustomerDetailRow } from '@sales-portal/domain/pricing/screens/customers/blocs/transformers/use-customer-detail-transformer';
import { PricingCustomerListRow } from '@sales-portal/domain/pricing/screens/customers/blocs/transformers/use-customer-list-transformer';

const LEFT_ALIGNED_COLUMNS = new Set<string>([
  // List screen
  ColumnId.AccountId,
  ColumnId.Name,
  ColumnId.SalesRep,
  // Detail screen
  DetailColumnId.Checkbox,
  DetailColumnId.ItemCode,
  DetailColumnId.Name,
  DetailColumnId.UOM,
]);

const DELTA_COLUMNS = new Set<string>([
  DetailColumnId.CostDelta,
  DetailColumnId.MarginDelta,
  DetailColumnId.PriceDelta,
  DetailColumnId.WeeklyEditsGrossProfitImpact,
]);

const INPUT_COLUMNS = new Set<string>([
  DetailColumnId.CurrentMargin,
  DetailColumnId.CurrentPrice,
]);

export const isLeftAlignedColumn = (columnId: string) =>
  LEFT_ALIGNED_COLUMNS.has(columnId);

export const isDeltaColumn = (columnId: string) => DELTA_COLUMNS.has(columnId);

export const isInputColumn = (columnId: string) => INPUT_COLUMNS.has(columnId);

export const customerListGlobalFilterFn: FilterFn<PricingCustomerListRow> = (
  row,
  _columnId,
  filterValue,
) => {
  const searchTerm = (filterValue as string).toLowerCase();
  return [
    row.original.restaurantName,
    row.original.restaurantAccountId,
    row.original.salesRepName,
  ].some((field) => field?.toLowerCase().includes(searchTerm));
};

export const customerDetailGlobalFilterFn: FilterFn<
  PricingCustomerDetailRow
> = (row, _columnId, filterValue) => {
  const searchTerm = (filterValue as string).toLowerCase();
  return [row.original.variantPackName, row.original.variantPackId].some(
    (field) => field.toLowerCase().includes(searchTerm),
  );
};
